import React, { useState } from "react";
import { IMAGES } from "../utils/images";
import "../Styles/signin.css";
import { Link } from "react-router-dom";
import LoginWithOptions from "./SignInComponents/LoginWithOptions";
import LoginForm from "./SignInComponents/LoginForm";

const SignIn = () => {
  const [activeTab, setActiveTab] = useState(0);
  const handleClick = async () => {
    try {
      const response = await fetch("http://localhost:3001/post", {
        method: "POST",
        headers: {
          "Content-Type": "appliction/json",
        },
        body: JSON.stringify({
          id: 1,
          name: "Mahal",
        }),
      });

      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  const tabs = [
    {
      name: "LoginWithOptions",
      component: LoginWithOptions,
    },
    {
      name: "LoginForm",
      component: LoginForm,
    },
  ];
  const ActiveTabComponent = tabs[activeTab].component;

  return (
    <div className="outlet-render">
      <div className="signin-main-container">
        <ActiveTabComponent call={setActiveTab} />

        <img
          src={IMAGES.SIGNIN_MAIN}
          alt="signin image"
          className="signin-right-container"
        />
      </div>
    </div>
  );
};

export default SignIn;
